// Module
var code = "<svg class=\"svg-icon\"> <use xlink:href=\"#[[ name ]]\"/> </svg> ";
// Exports
export default code;